var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("van-notice-bar", {
        attrs: {
          scrollable: "",
          text: "输入客户名称时，下方匹配出的客户代表本系统已存在，无需再录入。",
        },
      }),
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                attrs: {
                  label: "客户名称",
                  name: "companyName",
                  "input-align": "right",
                  readonly: "",
                  required: "",
                  rules: [{ required: true, message: "请输入客户名称" }],
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("el-autocomplete", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "mini",
                            filterable: "",
                            "fetch-suggestions": _vm.querySearch,
                            placeholder: "请输入客户名称",
                          },
                          model: {
                            value: _vm.formData.companyName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "companyName", $$v)
                            },
                            expression: "formData.companyName",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.companyName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "companyName", $$v)
                  },
                  expression: "formData.companyName",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "parentId",
                  value: _vm.formData.parentId,
                  label: "上级单位",
                  placeholder: "请选择上级单位",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.parentId,
                            placeholder: "请选择上级单位",
                            options: {
                              data: _vm.parentId.data,
                              showFields: "companyName",
                              valueKey: "id",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.parentId.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.parentId.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.parentId, "show", $$v)
                              },
                              expression: "parentId.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择上级单位",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.parentId.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("parentId", {
                                    value: "id",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.parentId,
                                    "companyName"
                                  )
                                },
                              },
                              model: {
                                value: _vm.parentId.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.parentId, "filterText", $$v)
                                },
                                expression: "parentId.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "parentId",
                              attrs: {
                                "value-key": "companyName",
                                columns: _vm.parentId.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.parentId.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyLevel",
                  value: _vm.formData.companyLevel,
                  label: "客户级别",
                  required: "",
                  rules: [{ required: true, message: "请选择客户级别" }],
                  placeholder: "请选择客户级别",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.companyLevel,
                            placeholder: "请选择客户级别",
                            options: {
                              data: _vm.companyLevel.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.companyLevel.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.companyLevel.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyLevel, "show", $$v)
                              },
                              expression: "companyLevel.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择客户级别",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.companyLevel.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("companyLevel", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.companyLevel,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.companyLevel.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyLevel, "filterText", $$v)
                                },
                                expression: "companyLevel.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "companyLevel",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.companyLevel.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.companyLevel.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyNature",
                  value: _vm.formData.companyNature,
                  label: "单位类型",
                  required: "",
                  rules: [{ required: true, message: "请选择单位类型" }],
                  placeholder: "请选择单位类型",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.companyNature,
                            placeholder: "请选择单位类型",
                            options: {
                              data: _vm.companyNature.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.companyNature.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.companyNature.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyNature, "show", $$v)
                              },
                              expression: "companyNature.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择单位类型",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.companyNature.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("companyNature", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.companyNature,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.companyNature.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyNature, "filterText", $$v)
                                },
                                expression: "companyNature.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "companyNature",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.companyNature.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.companyNature.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "customBase",
                  value: _vm.formData.customBase,
                  label: "客户规模",
                  required: "",
                  rules: [{ required: true, message: "请选择客户规模" }],
                  placeholder: "请选择客户规模",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.customBase,
                            placeholder: "请选择客户规模",
                            options: {
                              data: _vm.customBase.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.customBase.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.customBase.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.customBase, "show", $$v)
                              },
                              expression: "customBase.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择客户规模",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.customBase.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("customBase", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.customBase,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.customBase.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.customBase, "filterText", $$v)
                                },
                                expression: "customBase.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "customBase",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.customBase.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.customBase.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyIndustry",
                  value: _vm.formData.companyIndustry,
                  label: "行业",
                  required: "",
                  rules: [{ required: true, message: "请选择行业" }],
                  placeholder: "请选择行业",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.companyIndustry,
                            placeholder: "请选择行业",
                            options: {
                              data: _vm.companyIndustry.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.companyIndustry.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.companyIndustry.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyIndustry, "show", $$v)
                              },
                              expression: "companyIndustry.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择行业",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.companyIndustry.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("companyIndustry", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.companyIndustry,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.companyIndustry.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.companyIndustry,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "companyIndustry.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "companyIndustry",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.companyIndustry.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.companyIndustry.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companySource",
                  value: _vm.formData.companySource,
                  label: "客户来源",
                  placeholder: "请选择客户来源",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.companySource,
                            placeholder: "请选择客户来源",
                            options: {
                              data: _vm.companySource.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.companySource.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.companySource.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.companySource, "show", $$v)
                              },
                              expression: "companySource.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择客户来源",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.companySource.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("companySource", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.companySource,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.companySource.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companySource, "filterText", $$v)
                                },
                                expression: "companySource.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "companySource",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.companySource.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.companySource.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyEntrustType",
                  value: _vm.formData.companyEntrustType,
                  label: "业务委托形式",
                  placeholder: "请选择业务委托形式",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.companyEntrustType,
                            placeholder: "请选择业务委托形式",
                            options: {
                              data: _vm.companyEntrustType.data,
                              showFields: "dictLabel",
                              valueKey: "dictValue",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.companyEntrustType.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.companyEntrustType.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyEntrustType, "show", $$v)
                              },
                              expression: "companyEntrustType.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择业务委托形式",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.companyEntrustType.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("companyEntrustType", {
                                    value: "dictValue",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.companyEntrustType,
                                    "dictLabel"
                                  )
                                },
                              },
                              model: {
                                value: _vm.companyEntrustType.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.companyEntrustType,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "companyEntrustType.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "companyEntrustType",
                              attrs: {
                                "value-key": "dictLabel",
                                columns: _vm.companyEntrustType.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.companyEntrustType.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  name: "companyLegalPerson",
                  maxlength: "50",
                  autosize: "",
                  label: "法人",
                  placeholder: "请输入法人",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.companyLegalPerson,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "companyLegalPerson", $$v)
                  },
                  expression: "formData.companyLegalPerson",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "companyTelephone",
                  maxlength: "50",
                  autosize: "",
                  label: "联系电话",
                  placeholder: "请输入联系电话",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.companyTelephone,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "companyTelephone", $$v)
                  },
                  expression: "formData.companyTelephone",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyProvince",
                  value: _vm.formData.companyProvince,
                  required: "",
                  rules: [{ required: true, message: "请选择省份/直辖市" }],
                  label: "省份/直辖市",
                  placeholder: "请选择省份/直辖市",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.companyProvince,
                            placeholder: "请选择省份/直辖市",
                            options: {
                              data: _vm.companyProvince.data,
                              showFields: "label",
                              valueKey: "value",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.companyProvince.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.companyProvince.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyProvince, "show", $$v)
                              },
                              expression: "companyProvince.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择省份/直辖市",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.companyProvince.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.companyProvincePopupSubmit(
                                    "companyProvince",
                                    { value: "value" }
                                  )
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.companyProvince,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.companyProvince.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.companyProvince,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "companyProvince.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "companyProvince",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.companyProvince.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.companyProvince.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyCity",
                  value: _vm.formData.companyCity,
                  label:
                    _vm.formData.companyProvince != "110000" &&
                    _vm.formData.companyProvince != "120000" &&
                    _vm.formData.companyProvince != "500000" &&
                    _vm.formData.companyProvince != "310000"
                      ? "市"
                      : "区",
                  placeholder: "请选择省份/直辖市",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            value: _vm.formData.companyCity,
                            placeholder: `请选择${
                              _vm.formData.companyProvince != "110000" &&
                              _vm.formData.companyProvince != "120000" &&
                              _vm.formData.companyProvince != "500000" &&
                              _vm.formData.companyProvince != "310000"
                                ? "市"
                                : "区"
                            }`,
                            options: {
                              data: _vm.companyCity.data,
                              showFields: "label",
                              valueKey: "value",
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              _vm.companyCity.show = true
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.companyCity.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.companyCity, "show", $$v)
                              },
                              expression: "companyCity.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: `选择${
                                  _vm.formData.companyProvince != "110000" &&
                                  _vm.formData.companyProvince != "120000" &&
                                  _vm.formData.companyProvince != "500000" &&
                                  _vm.formData.companyProvince != "310000"
                                    ? "市"
                                    : "区"
                                }`,
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.companyCity.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.companyCityPopupSubmit(
                                    "companyCity",
                                    { value: "value" }
                                  )
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.companyCity,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.companyCity.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.companyCity, "filterText", $$v)
                                },
                                expression: "companyCity.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "companyCity",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.companyCity.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.companyCity.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm.formData.companyProvince != "110000" &&
              _vm.formData.companyProvince != "120000" &&
              _vm.formData.companyProvince != "500000" &&
              _vm.formData.companyProvince != "310000"
                ? _c("van-field", {
                    attrs: {
                      "input-align": "right",
                      name: "companyArea",
                      value: _vm.formData.companyArea,
                      label: "旗/县/区",
                      placeholder: "请选择旗/县/区",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "input",
                          fn: function () {
                            return [
                              _c("form-view-item", {
                                attrs: {
                                  value: _vm.formData.companyArea,
                                  placeholder: "请选择旗/县/区",
                                  options: {
                                    data: _vm.companyArea.data,
                                    showFields: "label",
                                    valueKey: "value",
                                  },
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    _vm.companyArea.show = true
                                  },
                                },
                              }),
                              _c(
                                "van-popup",
                                {
                                  attrs: { position: "bottom" },
                                  model: {
                                    value: _vm.companyArea.show,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.companyArea, "show", $$v)
                                    },
                                    expression: "companyArea.show",
                                  },
                                },
                                [
                                  _c("van-nav-bar", {
                                    attrs: {
                                      title: "选择旗/县/区",
                                      "left-text": "取消",
                                      "right-text": "确定",
                                    },
                                    on: {
                                      "click-left": function ($event) {
                                        _vm.companyArea.show = false
                                      },
                                      "click-right": function ($event) {
                                        return _vm.popupSubmit("companyArea", {
                                          value: "value",
                                        })
                                      },
                                    },
                                  }),
                                  _c("van-search", {
                                    attrs: { clearable: "", shape: "round" },
                                    on: {
                                      input: function ($event) {
                                        return _vm.pickerSearch(
                                          $event,
                                          _vm.companyArea,
                                          "label"
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.companyArea.filterText,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.companyArea,
                                          "filterText",
                                          $$v
                                        )
                                      },
                                      expression: "companyArea.filterText",
                                    },
                                  }),
                                  _c("van-picker", {
                                    ref: "companyArea",
                                    attrs: {
                                      "value-key": "label",
                                      columns: _vm.companyArea.filteredData,
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.companyArea.show = false
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1313076250
                    ),
                  })
                : _vm._e(),
              _c("van-field", {
                attrs: {
                  name: "companyPlace",
                  maxlength: "50",
                  autosize: "",
                  label: "详细地址",
                  placeholder: "请输入详细地址",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.companyPlace,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "companyPlace", $$v)
                  },
                  expression: "formData.companyPlace",
                },
              }),
              _c("van-field", {
                attrs: {
                  "input-align": "right",
                  name: "companyProvince",
                  value: _vm.formData.companyProvince,
                  label: "所属部门",
                  placeholder: "请选择所属部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("form-view-item", {
                          attrs: {
                            isShowIcon: false,
                            value: _vm.formData.deptId,
                            placeholder: "请选择所属部门",
                            options: {
                              data: _vm.jurisdictionDeptTree,
                              showFields: "label",
                              valueKey: "value",
                              childrenKey: "children",
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                attrs: {
                  name: "companyIntroduce",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "客户简介",
                  "show-word-limit": "",
                  placeholder: "请输入客户简介",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.companyIntroduce,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "companyIntroduce", $$v)
                  },
                  expression: "formData.companyIntroduce",
                },
              }),
              _c("van-field", {
                attrs: {
                  name: "remark",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "bottom-bar-placeholder" }, [
        _c("div", { staticClass: "bottom-bar flex" }, [
          _c(
            "div",
            {
              staticClass: "btn-item flex-1 bg-FFDB43",
              on: {
                click: function ($event) {
                  return _vm.submit(0)
                },
              },
            },
            [_vm._v(" " + _vm._s("确定") + " ")]
          ),
          _c(
            "div",
            {
              staticClass: "btn-item flex-2 bg-FFDB43",
              on: {
                click: function ($event) {
                  return _vm.submit(1)
                },
              },
            },
            [_vm._v(" " + _vm._s("保存并录入联系人") + " ")]
          ),
          _c(
            "div",
            { staticClass: "btn-item flex-1 bg-FF", on: { click: _vm.goBack } },
            [_vm._v(" " + _vm._s("返回") + " ")]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }